import React from "react";
import { Rectangle } from "recharts";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { myDashboardActiveBrandStore } from "@/features/my-dashboard/stores/my-dashboard-active-brand-store";

function MyDashboardChartCursor(props: any) {
  const { x, y, width, height } = props;

  return (
    <Rectangle
      x={x === 0 ? 0.5 : x}
      y={y}
      width={width}
      height={height}
      // 안쪽은 아주 연한 색으로, 테두리는 파란색으로
      fill="#F7F9FA" // 혹은 "none" 으로 해서 완전 투명하게도 가능
      stroke="#1272EF"
      strokeWidth={1}
      radius={6} // 모서리 둥글게
      cursor={"pointer"}
    />
  );
}

export default MyDashboardChartCursor;
